import enums from '../enums.js';

const componentNames = [
  'text',
  'textCaption',
  'textParagraph',
  'textLabel',
  'textTitle',
  'textHeading',
  'textAction',
  'textInput'
];
const config = {
  styleProperties: [
    enums.properties.FONT_FAMILY,
    enums.properties.FONT_SIZE,
    enums.properties.FONT_WEIGHT,
    enums.properties.LINE_HEIGHT,
    enums.properties.FONT_VARIATION
  ]
};

export default componentNames.reduce((obj, name) => Object.assign(obj, { [name]: config }), {});
